module.exports = __webpack_public_path__ + "img/fpc-min-size@icon.e74eeeeb.png";